import { render, staticRenderFns } from "./DeliveryPlanning.vue?vue&type=template&id=510af424&scoped=true&"
import script from "./DeliveryPlanning.vue?vue&type=script&lang=js&"
export * from "./DeliveryPlanning.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPlanning.vue?vue&type=style&index=0&id=510af424&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510af424",
  null
  
)

export default component.exports